/* eslint-disable camelcase */
import api from '@pray/shared/utils/api';

interface GiftCodeResponse {
  responded_at: string;
  object: string;
  data: {
    id: string;
    code: string;
    is_reusable: boolean;
    created_at: string;
    destroyed: boolean;
  };
}

export const enableGiftCode = async (artistId: string, enabled: boolean): Promise<GiftCodeResponse> => {
  if (!artistId) {
    throw new Error('Artist ID is required');
  }

  const url = `/web/studio/artists/${artistId}/gift-codes`;
  const data = { enable_gift_code: enabled };
  const response = await api.executePutRequest(url, data);

  return response.data as GiftCodeResponse;
};
